<template>
  <div>
    <v-autocomplete
      :value="article"
      :items="filterArticles"
      v-bind="$attrs"
      @change="changedTo"
      ref="select"
      :loading="loading"
      :clearable="clearable"
      :label="$i18n.t(label)"
      :rules="rules"
      @click:clear="clear"
      :search-input.sync="filter"
      autocomplete="nope"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div ripple class="height32">
          <h5 class="text-title">{{ data.item.name }}</h5>
        </div>
      </template>

      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.name }}
              <v-icon small v-if="selected(data.item)" style="float:right">mdi-check</v-icon>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>

      <template v-slot:append-item>
        <div class="actionBox">
          <v-btn small text color="info" @click="addArticleDialog = true">
            <v-icon>mdi-plus</v-icon>
            {{ $i18n.t("Add New Article") }}
          </v-btn>
        </div>
      </template>
    </v-autocomplete>

    <z-article-create
      :refreshArticles="fetchArticles"
      @closeArticleDialog="closeArticleDialog"
      :showDialog="addArticleDialog"
    ></z-article-create>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { commonMixin } from "@/mixins/common";
import { doGet } from "@/store/common/module/apis";
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";

@Component({
  name: "ArticleSelect",
  props: {
    value: {
      default: false,
    },
    label: {
      default: "Article",
    },
    clearable: {
      default: false,
    },
  },
  mixins: [Themeable, commonMixin],
})
export default class ArticleSelect extends (Vue, Themeable) {
  loading = true;
  filter = "";
  addArticleDialog = false;
  articles = [];
  article = null;

  clear() {
    this.filter = "";
    this.$emit("input", null);
  }

  closeArticleDialog() {
    this.addArticleDialog = false;
  }

  async fetchArticles(_fetch) {
    if (_fetch) {
      try {
        common.setLoading(true);
        this.articles = await doGet("/api/article/list");
        common.setLoading(false);
      } catch (e) {
        common.setLoading(false);
      }
    }
  }

  get filterArticles() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    const articles = this.articles;
    if (filterby == "") {
      return articles;
    } else {
      const fc = articles.filter(function (c) {
        return c.name.toLowerCase().indexOf(filterby) >= 0;
      });
      return fc;
    }
  }

  changedTo(newVal) {
    this.filter = "";
    if (newVal) this.article = newVal;
    if (newVal && newVal._id) {
      this.$emit("input", newVal._id);
      return;
    }
    if (!newVal) this.$emit("input", null);
  }

  async init() {
    const articles = this.articles;
    if (this.value) {
      for (let i = 0; i < articles.length; i++) {
        if (articles[i]._id === this.value) {
          this.article = articles[i];
          break;
        }
      }
    }
  }

  async mounted() {
    await this.fetchArticles(true);
    await this.init();
    this.loading = false;
  }

  selected(val) {
    if (val != null && val.type != null && this.article != null) {
      if (Array.isArray(this.article)) {
        for (let i = 0; i < this.article.length; i++) {
          if (val._id === this.article[i]._id) {
            return true;
          }
        }
      } else if (this.article != null && this.article._id != undefined) {
        if (val._id === this.article._id) {
          return true;
        }
      }
    }
    return false;
  }

  @Watch("value")
  async onValueChange() {
    if (this.value == "") {
      this.article = null;
    }
    await this.init();
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}
.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
